<template>
  <div>
    <div v-if="$vuetify.breakpoint.smAndDown || isMobileDesign" style="padding-right: 8px; padding-left: 8px; cursor: pointer;">
      <v-progress-circular
        v-if="savingStatus"
        indeterminate
        color="primary"
        size="24"
        width="2"
      >
        <v-icon v-if="status && status.identifier === 3" color="black">{{(status && status.identifier === 3) ? 'done' : 'radio_button_unchecked'}}</v-icon>
      </v-progress-circular>
      <v-hover v-else>
        <v-avatar slot-scope="{ hover }" :class="hover ? 'elevation-15' : ''"  class="accent white--text select-status" @click="finalizeStatus()" left size="30">
          <v-icon v-if="hover" color="green">done</v-icon>
          <v-icon v-else-if="status && status.identifier === 3" color="black">done</v-icon>
        </v-avatar>
      </v-hover>
    </div>
    <v-chip
      v-else
      small
      outline
      class="ma-1 pa-0 task-status-chip"
      color="#00acc1"
      text-color="white"
      style="position: relative"
    >
      <v-progress-circular
        v-if="savingStatus || ACLoading"
        class="savingStatus"
        indeterminate
        color="primary"
        size="24"
        width="2"
      >
        <v-icon v-if="status && status.identifier === 3" color="black">{{(status && status.identifier === 3) ? 'done' : 'radio_button_unchecked'}}</v-icon>
      </v-progress-circular>
      <!-- <v-hover v-else>
        <v-avatar slot-scope="{ hover }"
          :class="hover ? 'elevation-15' : ''" class="accent white--text select-status" @click="finalizeStatus()" left>
          <v-icon v-if="hover" color="green">done</v-icon>
          <v-icon v-else color="black">{{(status && status.identifier === 3) ? 'done' : 'radio_button_unchecked'}}</v-icon>
        </v-avatar>
      </v-hover> -->
      <v-hover v-else>
        <v-avatar slot-scope="{ hover }" :class="hover ? 'elevation-15' : ''" class="accent white--text select-status" @click="finalizeStatus()" left>
          <v-icon v-if="hover" color="green">done</v-icon>
          <v-icon v-else-if="status && status.identifier === 3" color="black">done</v-icon>
        </v-avatar>
      </v-hover>
      <span @click="selectStatus" v-if="view">
        <font color="black">{{(status ? status.id_text : '           ') | formatAbbreviation(15)}}</font>
      </span>
      <v-autocomplete
        v-else
        :id="`statusSelect${_uid}`"
        :value="status ? status.id_text : ''"
        @blur="() => {view = true}"
        item-value="id"
        :no-data-text="ACLoading ? 'Carregando...' : 'Nenhum status encontrado'"
        @click="getItems"
        :items="statusItems"
        item-text="id_text"
        :loading="ACLoading"
        @change="changeStatusProcess"
        style="max-width: 80px;"
        height="20px"
      >
      </v-autocomplete>
      <v-icon v-if="view" @click="selectStatus" color="black">arrow_drop_down</v-icon>
    </v-chip>
  </div>
</template>

<style scoped>
  .theme--light.v-small-dialog__content {
    background: #00acc1;
  }
  .theme--light.v-list {
    background: #00acc1;
  }
  .v-menu__content {
    box-shadow: null;
  }
  .select-status {
    background-color: white !important;
    border-style: solid !important;
    border-color: #00acc1 !important;
  }
  .savingStatus {
    right: 12px
  }
</style>

<script>
import stopWatch from './../../mixin/stopWatch'
import methodTaskSocket from './../../mixin/methodTaskSocket'

export default {
  /* eslint-disable eqeqeq, no-unneeded-ternary */
  mixins: [stopWatch, methodTaskSocket],
  props: ['status', 'isMobileDesign', 'task', 'companyId', 'task_id', 'readonly'],
  data () {
    return {
      statusItems: [{id_text: ''}],
      ACLoading: false,
      savingStatus: false,
      view: true,
      // Variavel changeUser criada pois quando existe o parametro changeUser ela recebe valor para alterar tanto no back como no front
      changeUser: null
    }
  },
  methods: {
    getItems () {
      this.ACLoading = true
      this.statusItems = []
      // busca o quadro selecionado para pegar os status selecionados e passar como parametro e buscar apenas aqueles status no banco
      let selectedBoard = this.$store.getters[`selectedBoard/values`]
      let onlyThisItems = selectedBoard['properties']['status'] ? selectedBoard['properties']['status'] : null
      let params = `?entity=task_status&onlyThisItems=${onlyThisItems ? onlyThisItems : ''}&value=${this.status['id'] ? this.status['id'] : ''}&per_page=1000&company_id=${this.companyId}`
      this.$http.get(`api/get_select_values${params}`).then((res) => {
        this.statusItems = res.body['data']
        this.ACLoading = false
      }, err => {
        this.ACLoading = false
        console.log(err)
        this.$store.commit('snackbar/change_values', { text: 'Não foi possível buscar os status, reporte o erro.', color: 'error', dialog: true })
      })
    },
    finalizeStatus (task_status_id = null) {
      // caso so seja pra visualizar não abre a lista de opções
      if (this.readonly) {
        this.$store.commit('snackbar/change_values', {text: 'Não é possível editar tarefas compartilhadas.', color: 'warning', timeout: 6000, dialog: true})
        return
      }
      this.savingStatus = true
      this.$http.post(`api/finalize_status`, {task_id: this.task_id, task_status_id: task_status_id}).then(
        res => {
          this.task['before_task_status_id'] = this.task['task_status_id']
          this.task['task_status_id'] = res.body['status'] ? res.body['status']['id'] : null
          // verifica necessidade do pop up para finalização dos filhos
          let tempTask = JSON.parse(JSON.stringify(this.task))
          let newStatus = res.body['status']
          this.$emit('statusFinalized', {task: tempTask, status: newStatus})
          // se tiver automações de lembretes chama eles
          if (res.body['automations'].length > 0) {
            this.$store.commit('automationMessage/change_values', {dialog: true, taskId: this.task_id, tasktemplateAutomationIds: res.body['automations']})
          }
          if (res.body['finalize_sons']) {
            // popup de um snackbar para finalização dos filhos
            this.$store.commit('snackbarButton/change_values', {
              text: 'Deseja finalizar as tarefas de níveis abaixo?',
              color: 'blue',
              buttonColor: 'blue',
              buttonText: 'Finalizar subtarefas',
              buttonFunction: () => {
                this.$store.commit('snackbarButton/change_values', {dialog: false})
                this.$http.get(`api/finalize_lower_tasks/${this.task.id}`).then(response => {
                  let taskItem = this.task
                  taskItem['status'] = res.body['status']
                  taskItem['participants'] = res.body['participants']
                  // Caso o tempo de alguma tarefa filha estiver rodando, finaliza ele.
                  let params = JSON.parse(this.$auth.user().company.params)
                  if (params['stopTime'] && params['stopTime']['active'] && params['stopTime']['status'].some((val) => { return val == taskItem['status']['id'] })) {
                    // verifica se alguma tarefa filha está com o tempo contando, se tiver, para o tempo
                    let stopWatchValues = this.$store.getters[`stopWatch/values`]
                    if (stopWatchValues['active'] && response.body['lowerTasksIds'] && response.body['lowerTasksIds'].some((val) => { return val == stopWatchValues['task_id'] })) {
                      this.closeDuration()
                    }
                  }
                  // Socket para atualizar a subtarefa na tela de gerenciamento de tarefas
                  this.$socket.emit('generalEvent', {
                    data: this.task.id,
                    notBroadcast: true,
                    responseEvent: 'reloadTaskSubTask',
                    room: `tasks${this.task.id}_manage`
                  })
                  // this.$emit('statusChanged')
                  this.afterChangeStatus(taskItem, true)
                  this.$store.commit('snackbar/change_values', { text: 'Tarefas filhas finalizadas com sucesso!', color: 'success', dialog: true })
                  if (res.body['finalize_father']) {
                    this.finalizeFather()
                  }
                }, err => {
                  console.log(err)
                  if (err.body.message === 'hasDependency') {
                    this.$store.commit('snackbar/change_values', {text: 'Existem pré-requisitos para esta tarefa.', color: 'warning', timeout: 6000, dialog: true})
                  } else if (err.body.message === 'dependentFinalized') {
                    this.$store.commit('snackbar/change_values', {text: 'Para alterar o status desta tarefa, ela não pode ser pré-requisito de uma tarefa já finalizada.', color: 'warning', timeout: 10000, dialog: true})
                  } else if (err.body.message === 'dependentFinalized') {
                    this.dependentDialog = true
                  }
                })
              },
              dialog: true
            })
          } else if (res.body['finalize_father']) {
            // popup para finalização da task pai
            this.finalizeFather()
          }
          var taskItem = this.task
          taskItem['status'] = res.body['status']
          taskItem['participants'] = res.body['participants']
          taskItem['delTaskUsers'] = res.body['delTaskUsers']
          this.afterChangeStatus(taskItem)
        }, err => {
          this.savingStatus = false
          console.log(err)
          if (err.body.message === 'notFoundTask') {
            this.$store.commit('snackbar/change_values', {text: 'Não foi possível editar. Recarregue a página e verifique se a tarefa ainda existe no sistema.', timeout: 10000, color: 'warning', dialog: true})
          } else if (err.body.message === 'actionDenied') {
            this.$store.commit('snackbar/change_values', {text: 'Apenas os administradores da empresa, responsáveis da equipe ou o responsável da tarefa podem edita-la.', color: 'warning', timeout: 10000, dialog: true})
          } else if (err.body.message === 'hasDependency') {
            this.$store.commit('snackbar/change_values', {text: 'Existem pré-requisitos para esta tarefa.', color: 'warning', timeout: 6000, dialog: true})
          } else if (err.body.message === 'dependentFinalized') {
            this.$store.commit('snackbar/change_values', {text: 'Para alterar o status desta tarefa, ela não pode ser pré-requisito de uma tarefa já finalizada.', color: 'warning', timeout: 10000, dialog: true})
          } else {
            this.$store.commit('snackbar/change_values', {text: 'Não foi possível editar o registro de ' + this.translate('table.' + this.entity + '.title')[0] + ', reporte o erro.', color: 'error', dialog: true})
          }
        })
    },
    finalizeFather () {
      this.$store.commit('snackbarButton/change_values', {
        text: 'Deseja finalizar a tarefa mãe?',
        color: 'blue',
        buttonColor: 'blue',
        buttonText: 'Finalizar Tarefa',
        buttonFunction: () => {
          this.$store.commit('snackbarButton/change_values', {dialog: false})
          this.$http.post(`api/finalize_status`, {task_id: this.task.task_id}).then(res => {
            // insere o status e os participantes nos valores da tarefa mãe para poder alterar no socket
            // insere o finalize_father pois ele é verificado no socket se veio da opção de finalizar o pai, pois se tiver vindo deve dar um reload
            let taskItem = {id: this.task.task_id, task_status_id: res.body['status']['id'], status: res.body['status'], before_task_status_id: res.body['before_task_status_id'], finalize_father: true}
            taskItem['status'] = res.body['status']
            taskItem['participants'] = res.body['participants']
            // Caso o tempo da tarefa mãe estiver rodando, finaliza ele.
            let params = JSON.parse(this.$auth.user().company.params)
            if (params['stopTime'] && params['stopTime']['active'] && params['stopTime']['status'].some((val) => { return val == taskItem['status']['id'] })) {
              // verifica se a tarefa mae está com o tempo contando, se tiver, para o tempo
              let stopWatchValues = this.$store.getters[`stopWatch/values`]
              if (stopWatchValues['active'] && stopWatchValues['task_id'] == this.task.task_id) {
                this.closeDuration()
              }
            }
            // joga o socket para atualizar a tarefa pai na tela de gerenciamento de tarefas quando ela é editada
            this.$socket.emit('generalEvent', {
              data: {values: taskItem, entity: 'tarefa'},
              notBroadcast: true,
              responseEvent: 'editSocketManagementDetails',
              room: `tasks${this.task.task_id}_manage`
            })
            this.afterChangeStatus(taskItem, true)
            this.$store.commit('snackbar/change_values', { text: 'Tarefa mãe finalizada com sucesso!', color: 'success', dialog: true })
          }, err => {
            console.log(err)
            if (err.body.message === 'notFoundTask') {
              this.$store.commit('snackbar/change_values', {text: 'Não foi possível editar. Recarregue a página e verifique se a tarefa ainda existe no sistema.', timeout: 10000, color: 'warning', dialog: true})
            } else if (err.body.message === 'hasDependency') {
              this.$store.commit('snackbar/change_values', {text: 'Existem pré-requisitos para esta tarefa.', color: 'warning', timeout: 6000, dialog: true})
            } else if (err.body.message === 'dependentFinalized') {
              this.$store.commit('snackbar/change_values', {text: 'Para alterar o status desta tarefa, ela não pode ser pré-requisito de uma tarefa já finalizada.', color: 'warning', timeout: 10000, dialog: true})
            } else {
              this.$store.commit('snackbar/change_values', {text: 'Não foi possível finalizar a tarefa!.', color: 'error', dialog: true})
            }
          })
        },
        dialog: true
      })
    },
    changeStatusProcess (val) {
      // muda o status apenas se for status diferente
      // Verifica o status pois o status pode começar sem status não tendo o id
      if (val != (this.status ? this.status['id'] : null)) this.changeStatus(val)
      this.view = true
    },
    changeStatus (id) {
      let status = this.statusItems.find((item) => { return item.id === id })
      // verifica se o status é finalizado para usar a função de finalizar
      if (status && status['identifier'] === 3) {
        this.finalizeStatus(id)
      } else {
        this.savingStatus = true
        let value = {id: this.task_id, task_status_id: id}
        // Se o parametro da empresa "mudar o usuário" estiver ativo contendo o status, altera o usuário da tarefa para o usuário logado
        let params = JSON.parse(this.$auth.user().company.params)
        // Variavel changeUser criada pois quando existe o parametro changeUser ela recebe valor para alterar tanto no back como no front
        this.changeUser = null
        if (params.hasOwnProperty('changeUser') && params['changeUser']['active'] && params['changeUser']['status'].some((val) => { return val == id })) {
          this.changeUser = {}
          // inclui os valores no changeuser para mudar no front
          Object.assign(this.changeUser, {user_id: this.$auth.user().id, user: {id: this.$auth.user().id, id_text: this.$auth.user().id_text, email: this.$auth.user().email, photo_path: this.$auth.user().photo_path}})
          // inclui o usuário no value para mudar no back no back
          Object.assign(value, {'user_id': this.$auth.user().id})
        }
        this.$http.put(`api/tasks/${value.id}`, value).then(res => {
          // se tiver automações de lembretes chama eles
          if (res.body['automations'].length > 0) {
            this.$store.commit('automationMessage/change_values', {dialog: true, taskId: this.task_id, tasktemplateAutomationIds: res.body['automations']})
          }
          this.afterChangeStatus(res.body)
        }, err => {
          this.savingStatus = false
          console.log(err)
          if (err.body.message === 'actionDenied') {
            this.$store.commit('snackbar/change_values', {text: 'Apenas os administradores da empresa, responsáveis da equipe ou o responsável da tarefa podem edita-la.', color: 'warning', timeout: 10000, dialog: true})
          } else {
            this.$store.commit('snackbar/change_values', {text: 'Não foi possível editar o registro de ' + this.translate('table.' + this.entity + '.title')[0] + ', reporte o erro.', color: 'error', dialog: true})
          }
        })
      }
    },
    // reloadTask usado para recarregar todas as tarefas(Quando o ususpario finalizar a mae ou finalizar todas as filhas)
    afterChangeStatus (task, reloadTasks) {
      this.companyParamsTime(task)
      if (reloadTasks) {
        for (let user in task.participants) {
          this.$socket.emit('generalEvent', {
            data: task,
            notBroadcast: true,
            responseEvent: 'reloadTasks',
            room: `tasks${task.participants[user]}`
          })
        }
      } else {
        let beforeTask = {status: this.status}
        // Adiciona no old_user_id pois ele é necessário em comparação no methodEditTaskSocket
        task['old_user_id'] = task['user_id']
        this.methodEditTaskSocket(task, beforeTask, true, true)
      }
      // before_status_identifier verifica se houve mudança de identifier do status e armazena o antigo, caso haja alteraçção e o atual é 3 manda socket para calendario
      if (!!task.before_status_identifier && task.status.identifier === 3) {
        for (var element in task.participants) {
          this.$socket.emit('generalEvent', {
            data: task,
            responseEvent: 'deleteSocketCalendarTask',
            room: `calendar${task.participants[element]}`
          })
        }
      }
      // caso haja mudança e o identifier antigo é de finalizado addiciona o via socket a tarefa no calendario
      if (!!task.before_status_identifier && task.before_status_identifier === 3) {
        for (element in task.participants) {
          this.$socket.emit('generalEvent', {
            data: task,
            responseEvent: 'addSocketCalendarTask',
            room: `calendar${task.participants[element]}`
          })
        }
      }
      this.$store.commit('snackbar/change_values', {
        text: 'Registro de tarefa foi editado com sucesso!', color: 'success', dialog: true
      })
      this.savingStatus = false
      // Inclui o changeUser no status pois caso ao mudar o status o parametr da empresa de mudar o responsável esteja ativo, deve mandar as informações para mudar no front
      task.status['changeUser'] = this.changeUser
      this.$emit('change', task.status)
      // Limpa changeUser
      this.changeUser = null
    },
    selectStatus () {
      // caso so seja pra visualizar não abre a lista de opções
      if (this.readonly) {
        this.$store.commit('snackbar/change_values', {text: 'Não é possível editar tarefas compartilhadas.', color: 'warning', timeout: 6000, dialog: true})
        return
      }
      setTimeout(() => {
        document.getElementById(`statusSelect${this._uid}`).click()
      }, 400)
      this.view = false
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/shared/PSelectStatus.vue